// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3RPze","list":"PatternAutocomplete_list__1IAHm"};